<link href="https://unpkg.com/ngx-bootstrap/datepicker/bs-datepicker.css" rel="stylesheet">
<header class="admin-header">
  <nav class="navbar navbar-expand-lg">
    <div class="container align-items-end">
      <a [routerLink]="['/home']" *ngIf="isStudent"><img src="assets/images/site/login-logo.png" alt="Logo"></a>
      <a [routerLink]="['/admin']" *ngIf="!isStudent"><img src="assets/images/site/login-logo.png" alt="Logo"></a>

      <div class="header-btn">
        <ul>
          <li>
            <a [routerLink]="['/home/skill/add']" class="btn btn-themePrimary btn-icon" *ngIf="isStudent"><i
                class="fa-solid fa-circle-plus"></i></a>
          </li>
          <li>
            <div class="btn-group" dropdown #dropdown="bs-dropdown">
              <div style="width: 100%;z-index:998;">
                <button id="dropdownBasic1" type="button" dropdownToggle
                  class="btn btn-themelight1 btn-iconText dropdown-toggle" aria-controls="dropdown-basic"><i
                    class="fa-solid fa-user"></i>{{userName}}
                </button>
              </div>
              <div>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                  <li role="menuitem" *ngIf="isAuthenticated && !isStudent">
                    <a class="dropdown-item" [routerLink]="['/home/skill/add']"><i class="fa fa-user"></i> Portfolio</a>
                  </li>
                  <li role="menuitem" *ngIf="isAuthenticated && !isStudent">
                    <a class="dropdown-item" [routerLink]="['/admin']"><i class="fa fa-gear"></i> Admin</a>
                  </li>
                  <li role="menuitem" *ngIf="isAuthenticated">
                    <a class="dropdown-item" href="javascript:void(0)" (click)="openChangeEmailModal(changeEmailTemplate)"><i class="fa fa-envelope"></i> Change email</a>
                  </li>
                  <li role="menuitem" *ngIf="isAuthenticated">
                    <a class="dropdown-item" (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li><a href="javascript:void(0)" routerLink="/home/print" class="btn btn-theme1 btn-iconText">
              <i class="fa-solid fa-print"></i>
              Print</a>
          </li>
        </ul>
      </div>
    </div>

  </nav>
</header>

<ng-template #changeEmailTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Change email</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="emailChangeModalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <form [formGroup]="emailChangeForm" (ngSubmit)="requestEmailChange()">
    <div class="modal-body">
      <div class="mb-3" *ngIf="loginUser?.email">
        <label class="form-label">Current email address</label>
        <div>{{loginUser?.email}}</div>
      </div>
      <div class="mb-3">
        <label for="newEmail" class="form-label">New email address</label>
        <input id="newEmail" type="email" class="form-control" formControlName="newEmail" autocomplete="email">
        <div class="text-danger mt-1" *ngIf="emailChangeForm.get('newEmail')?.touched && emailChangeForm.get('newEmail')?.invalid">
          Enter a valid email address.
        </div>
      </div>
      <div class="alert alert-success" *ngIf="emailChangeSuccessMessage">
        {{emailChangeSuccessMessage}}
      </div>
      <div class="alert alert-danger" *ngIf="emailChangeErrorMessage">
        {{emailChangeErrorMessage}}
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-grey" (click)="emailChangeModalRef?.hide()" [disabled]="isSubmittingEmailChange">Close</button>
      <button type="submit" class="btn btn-themePrimary" [disabled]="isSubmittingEmailChange">
        {{isSubmittingEmailChange ? 'Sending...' : 'Send verification email'}}
      </button>
    </div>
  </form>
</ng-template>
